import ReactDOM from "react-dom";

import { ApiSettings } from "@/Common/Api/ApiSettings";
import { ResetPasswordControl } from "@/Common/Components/Password/ResetPasswordControl";
import { Locale } from "@/Common/Models/Localization/Locale";
import { ResourceProvider } from "@/Common/Resources/StaticResources";
import { PasswordResetPage } from "@/Common/Resources/StaticResourcesFor";
import { SessionStore } from "@/Globals/Stores/SessionStore";

export class PasswordResetApp {
    public start(elementId: string, token: string, locale: Locale, rootPath: string, redirectTo: string): void {
        window.apiSettings = new ApiSettings(baseURI + rootPath);
        window.sessionStore = SessionStore.createSingleton();

        if (!elementId)
            throw new TypeError("Element id must be provided");

        const elem = document.getElementById(elementId);
        if (!elem)
            throw new TypeError("HTML element by id not found");

        ReactDOM.render(
            <ResetPasswordControl
                token={token}
                onClosePopupCallBack={() => window.location.href = redirectTo}
                popupTitle="ChangePasswordTitle"
                stringProvider={new ResourceProvider(new PasswordResetPage(), locale)}
            />,
            elem
        );
    }
}
